
import { UIService } from '../../ui.service';

import { Component, AfterContentInit, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';


import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { UserService } from '../../user.service';
import { HelpType } from '../../components/common/help/help.service';
import { FormAction, CancelFormAction, FormConfig, FormDialogResponse } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { SupportSessionDTO } from '../../api/plyca-dtos-v2';
import { ConfirmationService } from 'primeng-lts/api';
import { TenderingBaseAction } from '../../dossiers/eTenderingDefinition/tenderingBase.component';
import { FieldConfig } from '../../api/contract-notice-dto';
import { take } from 'rxjs/operators';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { ActionDTO } from '../../api/plyca-dtos';
import { FormService } from '../../components/forms/form.service';


@Component({
  selector: 'support-sessions',
  templateUrl: 'supportSessions.template.html',
  providers: [DialogService, UIService, DatePipe]
})
export class SupportSessionsComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {

  private loaded = false;
  elements = [];

  CANCEL_ACTION: any;
  plycaErrorHandler: any;


  filters: any = {};
  FROM_PARAM = 'from';
  TO_PARAM = 'to';
  USER_PARAM = 'user';
  RESOURCE = 'contractFolderId';

  constructor(
    private headerActionsService: HeaderActionsService, // Servicio para el componente sub-header título y botones
    private elem: ElementRef,                             // Referencia necesaria para el servicio anterior
    public plycaService: PlycaDataService,              // Servicio de accesoa REST de servidor
    public uiService: UIService,                       // Servicios de interfaz como: mostrar un mensaje, ...
    public waitService: WaitLoadingService,            // Servicio para mostrar la capa de espera mientras hay procesos que tarden
    // o haya que bloquear la pantalla
    // Al menos en todas las llamadas al servidor.
    // private translationService: TranslateService,        // Servicio para obtener los textos internacionalizados
    private configuration: Configuration,                  // Configuración de las urls de los REST de servidor
    private datePipe: DatePipe,
    private translationService: TranslateService,
    private userService: UserService,
    private confirmationService: ConfirmationService,
    private dialogService: DialogService,
    private formService: FormService
  ) {
    super();
    // this.helpService.showContextHelp([HelpType.SESIONS]);



  }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  ngOnDestroy() {
    this.uiService = null;
    this.datePipe = null;

    super.ngOnDestroy();
  }



  // Método para inicializar el componente sub-header y habitualmente también el contexto de la ayuda.
  ngAfterContentInit(): void {


    this.headerActionsService.setTaskDescription(this.elem, 'ControlPanel.supportSessions.title', 'fas fa-user-shield',
      this.isLoaded.bind(this));
    this.waitService.startWaiting();


    this.subscribe(this.plycaService.getAvailableAction('SUPPORT_SESSION_AUDIT', this.userService.getUserId(), 'USER').pipe(finalize(() => {
      this.generalActions();

    })), (datos: any) => {
      if (datos && datos.actions) {
        datos.actions.forEach(action => {

          this.subscribe(this.headerActionsService.addAction(
            action.name,
            action.icon,
            'btn-secondary',
            true
          ), success => {
            this.openModalAction(action).onClose.pipe(take(1)).subscribe();
          });
        });
      }
    });


  }
  generalActions() {
    this.subscribe(this.headerActionsService.addAction(
      'ControlPanel.supportSessions.new',
      'fas fa-plus',
      'btn-primary',
      true
    ), success => {
      this.add();
    });
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });
    this.initFilters();
    this.load();
  }

  openModalAction(action: ActionDTO) {

    let config: DynamicDialogConfig = {
      header: action.name,

      width: '70%',
      styleClass: 'actionStyle',
      style: { overflow: 'hidden' }


    };
    config['action'] = action;
    config['paramsDef'] = action;


    return this.dialogService.open(ActionsProcessComponent, config);


  }


  isLoaded(): boolean {
    return this.loaded;
  }
  isLoadedResult() {
    return this.isLoaded() && (this.elements && this.elements.length > 0);
  }

  add() {



    let actions = new Array<FormAction<any>>();
    actions.push(this.getActionForm());
    actions.push(new CancelFormAction());


    let data = new SupportSessionDTO();
    //data.identifier = 'new';


    let config: DynamicDialogConfig = {
      header: this.translationService.instant('ControlPanel.supportSessions.new'),
      width: '70%',
      styleClass: 'formEdition'
    };

    config['formConfig'] = new FormConfig(undefined,
      'admin/supportSessionsISettings.json',
      data,
      actions,
      true, false

    );
    config['formConfig'].isModalWindow = true;
    config['formConfig'].searchTags = HelpType.CREATE_ACTIONS;
    config['formConfig'].showValidations = true;

    const dialogRef = this.dialogService.open(formPlycaComponent, config);

    this.subscribe(dialogRef.onClose, (response: FormDialogResponse<any>) => {
      this.load();
      if (response && response.actionId !== this.CANCEL_ACTION.actionId) {
        // this.emitUpdate(rowData, response.model);

      }
    },
      (error: any) => {
        const ref = this.plycaErrorHandler.showServerError(error);
        this.subscribe(ref.onClose);

        console.log(error);
      }
    );

  }
  remove(element: any) {
    this.confirmationService.confirm({
      message: this.translationService.instant('Forms.table.deleteRow'),
      acceptLabel: this.translationService.instant('General.yes'),
      rejectLabel: this.translationService.instant('General.no'),
      accept: () => {

        const action = this.getActionForm();
        this.waitService.startWaiting();
        this.subscribe(action.executeFormAction(element).pipe(finalize(() => this.load())));
      }
    });
  }


  dtoToBean(data: any): any {
    return data;
  }
  beanToDTO(data: SupportSessionDTO): any {
    data.user = this.userService.getUser();
    return data;
  }

  getDialogConfig(titleKey?: string): DynamicDialogConfig {
    return {
      header: this.translationService.instant('AwardCriteriaFormula.title'),
      width: '90%',
      styleClass: 'formEdition',
      closable: true,
      closeOnEscape: true
      //    baseZIndex: 1510
    } as DynamicDialogConfig;
  }

  emitUpdate(rowData?: any, updatedData?: any): void {
    this.load();
  }
  load() {
    this.waitService.startWaiting();

    //params.expand = 'expansionSet:CLIENTE_WEB';

    // params.userIdentifier = this.userService.getUserId();

    let params = {};
    if (this.filters[this.USER_PARAM] && this.filters[this.USER_PARAM].identifier) {
      params['userIdentifier'] = this.filters[this.USER_PARAM].identifier;
    }
    /*
    if (this.filters[this.TO_PARAM]) {
      params['endDate'] = this.filters[this.TO_PARAM].getTime();
    }

    if (this.filters[this.FROM_PARAM]) {
      params['startDate'] = this.filters[this.FROM_PARAM].getTime();
    }
*/
    if (this.filters[this.RESOURCE]) {
      params[this.RESOURCE] = this.filters[this.RESOURCE];
    }
    params['excludeNonActiveSessions'] = true;
    let observable = this.plycaService.query(this.configuration.SUPPORTSESSIONS_SERVICE_URL, params);
    this.subscribe(observable.pipe(finalize(() => {
      this.loaded = true;
      this.waitService.cancelWaiting();
    }
    )), (result: any) => {
      if (result) {
        this.elements = result.content;

      } else {
        this.elements = [];
      }
    });

  }

  getActionForm(): FormAction<any> {
    return new TenderingBaseAction<any>(this.plycaService,
      this.confirmationService,
      this.translationService,
      this.waitService,
      this.formService,
      this.getServiceURL(),
      this.getValidationCtx(),
      this.beanToDTO,
      undefined,
      'General.save', 'btn btn-primary', 'fa fa-save', 'aceptar');

  }

  getServiceURL(): string {
    return (this.configuration.SUPPORTSESSIONS_SERVICE_URL

    );
  }
  getValidationCtx(): string {
    return '';
  }



  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    config.fieldStyle = 'col-12 col-md-4';
    config.jsonField = name;
    if (name === this.FROM_PARAM) {
      config.type = 'DATE';
      config.description = this.translationService.instant('General.date.ini');
    } else if (name === this.TO_PARAM) {
      config.type = 'DATE';
      config.description = this.translationService.instant('General.date.end');
    } else if (name === this.USER_PARAM) {
      config.type = 'SEARCH';
      config.description = this.translationService.instant('ControlPanel.supportSessions.anagrama');
      config.idBuscador =
        'com.nexusit.framework.buscador.interfaz.BuscadorUsuarios';
      config.autoSearch = false;
      config.editable = false;
      config.fieldStyle = 'col-12 col-md-4';
    } else if (name === this.RESOURCE) {
      config.type = 'STRING';
      config.description = this.translationService.instant('General.project');
      config.fieldStyle = 'col-12 col-md-4';
    }
    return config;
  }

  initFilters() {
    this.filters[this.USER_PARAM] = this.userService.getUser();
    let fromDate = new Date();
    fromDate.setMonth(fromDate.getMonth() - 1);
    this.filters[this.FROM_PARAM] = fromDate;
  }


}
